import { Typography } from "@povio/ui";

import { NumbersMobile } from "@/components/shared/layout/profile-numbers/NumbersMobile";
import { ProfileNumbers } from "@/components/shared/layout/profile-numbers/ProfileNumbers";
import { AuthContext } from "@/data/auth/auth.context";
import { CommonModels } from "@/data/common/common.models";
import useUserProfileAndWorthData from "@/hooks/useUserProfileAndWorthData";
import { useWorthNumbersRandomizer } from "@/hooks/useWorthNumbersRandomizer";

export const HeaderNumbers = () => {
  const { userProfile, worthData } = useUserProfileAndWorthData();
  const { user: authUser } = AuthContext.useAuth();

  const worthDataStatus = worthData?.status ?? CommonModels.StatusEnum.no_data;
  const isProcessingWorthData =
    worthDataStatus === CommonModels.StatusEnum.processing ||
    worthDataStatus === CommonModels.StatusEnum.processing_full;
  const isProcessingWorthDataFailed = worthDataStatus === CommonModels.StatusEnum.failed;

  const historicalNumberValue = worthData?.historical ?? null;
  const yourNumberValue = worthData?.current ?? null;
  const impliedNumberValue = worthData?.implied ?? null;
  const totalMissingValue = worthData?.totalMiss ?? 0;

  const {
    historicalNumber,
    yourNumber,
    targetValue,
    totalMissingValue: randomMissing,
  } = useWorthNumbersRandomizer(isProcessingWorthData, {
    seedYour: yourNumberValue ?? undefined,
    seedHistorical: historicalNumberValue ?? undefined,
    percentageVariance: 10,
    intervalMs: 1200,
  });

  let renderedHistoricalValue: number | null = null;
  if (isProcessingWorthDataFailed) {
    renderedHistoricalValue = -1;
  } else if (isProcessingWorthData) {
    renderedHistoricalValue = historicalNumber ?? 0;
  } else {
    renderedHistoricalValue = historicalNumberValue;
  }

  let renderedYourValue: number | null = null;
  if (isProcessingWorthDataFailed) {
    renderedYourValue = -1;
  } else if (isProcessingWorthData) {
    renderedYourValue = yourNumber ?? 0;
  } else {
    renderedYourValue = yourNumberValue;
  }

  let renderedTargetValue: number | null = null;
  if (isProcessingWorthDataFailed) {
    renderedTargetValue = -1;
  } else if (isProcessingWorthData) {
    renderedTargetValue = targetValue ?? 0;
  } else {
    renderedTargetValue = impliedNumberValue ?? historicalNumberValue ?? yourNumberValue ?? 100000;
  }

  let renderedMissingValue: number | null = null;
  if (isProcessingWorthDataFailed) {
    renderedMissingValue = -1;
  } else if (isProcessingWorthData) {
    renderedMissingValue = randomMissing ?? 0;
  } else {
    renderedMissingValue = totalMissingValue;
  }

  const firstName = authUser?.user.name?.split(" ").shift() ?? "User";
  const jobPosition = userProfile?.jobPosition ?? null;

  if (isProcessingWorthDataFailed) {
    return (
      <NumbersMobile className="gap-px! px-0! py-4">
        <Typography
          size="title-4"
          variant="prominent-1"
          className="text-danger-200!"
        >
          Failed to calculate numbers, please try to re-calculate again
        </Typography>
      </NumbersMobile>
    );
  }
  return (
    <NumbersMobile className="gap-px! px-0! py-4">
      <ProfileNumbers
        firstName={firstName}
        isPrivate={true}
        isProcessingWorthData={isProcessingWorthData}
        jobPosition={jobPosition}
        renderedHistoricalValue={renderedHistoricalValue}
        renderedMissingValue={renderedMissingValue}
        renderedTargetValue={renderedTargetValue}
        renderedYourValue={renderedYourValue}
        worthDataStatus={worthDataStatus}
      />
    </NumbersMobile>
  );
};
